"use client";

import type { AnnotatedImage } from "@/schemas/analyzed-property";
import { useState } from "react";
import { QuickVisualGallery } from "./quick-visual-gallery";
import { ReimagineModal } from "./reimagine-modal";

interface QuickVisualGallerySectionProps {
  images: AnnotatedImage[];
  analysisId: string;
}

export function QuickVisualGallerySection({
  images,
  analysisId,
}: QuickVisualGallerySectionProps) {
  const [isReimagineModalOpen, setIsReimagineModalOpen] = useState(false);
  const [selectedReimagineImage, setSelectedReimagineImage] = useState<
    string | null
  >(null);

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-1.5">
        <h3 className="text-lg font-semibold">Visual Insights</h3>
        <p className="text-sm text-muted-foreground">
          AI-analyzed spaces with reimagining capabilities
        </p>
      </div>
      <QuickVisualGallery
        images={images}
        onReimagineClick={(imageUrl) => {
          setSelectedReimagineImage(imageUrl);
          setIsReimagineModalOpen(true);
        }}
      />
      {selectedReimagineImage && (
        <ReimagineModal
          open={isReimagineModalOpen}
          onOpenChange={setIsReimagineModalOpen}
          imageUrl={selectedReimagineImage}
          analysisId={analysisId}
        />
      )}
    </div>
  );
}
